export default function CallToAction({ lang = "de" }) {
  let translatedCallToAction = "Zum Stock Chart";
  if (lang === "en") {
    translatedCallToAction = "View Stock Chart";
  }

  let stockChartLink =
    "https://www.swisslife.com/de/home/investoren/swisslife-aktie.html";
  if (lang === "en") {
    stockChartLink =
      "https://www.swisslife.com/en/home/investors/swisslife-share.html";
  }

  return (
    <div className="call-to-action" style={{ textAlign: "right" }}>
      <a
        className="a-link a-link--content a-link--icon"
        href={stockChartLink}
        target="_self"
      >
        <span className="a-link__text">{translatedCallToAction}</span>
        <span className="a-link__icon-after">
          <svg
            className="a-svg a-svg--icon a-svg--arrow-right-16"
            role="presentation"
            focusable="false"
          >
            <use xlinkHref="/etc.clientlibs/slevo/clientlibs/site/resources/sprites.svg#arrow-right-16" />
          </svg>
        </span>
      </a>
    </div>
  );
}
